export default __webpack_public_path__ + "static/media/patients.f7c0e3b5.svg";